<template>
  <div name="task_vue">
    <el-container>
      <div id="printTest1">
        <div class="header-wrap">
          <el-header
            class="task_header notprint"
            :style="task_header_s"
            height="32px"
          >
            <div class="btn_region_in">
              <h3
                ref="flowSubject"
                style="text-align:left"
                class="top-subject-col"
              >
                {{workOrderNo}}-{{ subject }}
              </h3>
              <div class="top-btns-col no-print" v-if="show">
                <el-button
                  type="text"
                  icon="el-icon-document-copy"
                  v-if="showCopyBtn"
                  @click="copeInst()"
                  >复制</el-button
                >
                <el-button
                  type="text"
                  icon="icon-folder-add"
                  v-if="!taskId && type != 'read' && !myReadType"
                  @click="taskUrgent"
                  >催办</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-search"
                  v-if="type != 'read' && !myReadType"
                  @click="urgentRecord"
                  >催办记录</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-s-unfold"
                  v-if="showModifyRecord"
                  @click="openModifyRecord"
                  >修改记录</el-button
                >
                <el-button type="text" icon="icon-trace" @click="taskFollow"
                  >跟踪</el-button
                >
                <el-button type="text" icon="icon-print" @click="showPrint"
                  >打印</el-button
                >
                <!-- <el-button
                type="text"
                icon="icon-communication"
                @click="taskToCommu"
                >沟通</el-button
              >-->
                <el-button type="text" icon="icon-folder" @click="taskToCopyTo"
                  >传阅</el-button
                >
                <el-button type="text" icon="icon-flow1" @click="taskImage"
                  >流程图</el-button
                >
                <el-button
                  type="text"
                  icon="icon-info"
                  @click="relatedInformation"
                  >相关信息</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-coin"
                  @click="infoDialogVisible = true"
                  >处理记录</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  v-if="showDelete"
                  @click="deleteBpm"
                  >删除</el-button>
              </div>
            </div>
          </el-header>
        </div>
        <div ref="print">
          <FlowAction
            ref="flowAction"
            v-if="type != 'doneList'"
            :instId="procInstId"
            :type="type"
            :taskId="taskId"
            :task_state="task_state"
            :execId="execId"
            :defId="defId"
            :status="status"
            :tasks="tasks"
            :readId="readId"
            :myReadType="myReadType"
            :readDoneId="readDoneId"
            :choiceExcutor="choiceExcutor"
            :jumpType="jumpType"
            :instStatus="instStatus"
            :leaderId="leaderId"
            :approvalArea="approvalArea"
            :referOpinion="referOpinion"
            :nodeType="nodeType"
            :nodeId="nodeId"
            :workOrderNo="workOrderNo"
            :isNodeIdOne="isNodeIdOne"
            :opinionField="opinionField"
            :opinionFieldList="opinionFieldList"
            :appendOpinion="appendOpinion"
            :isLook="isLook"
          />
          <DoneAction
            v-if="type == 'doneList'"
            ref="doneAction"
            :instId="procInstId"
            :type="type"
            :taskId="taskId"
            :defId="defId"
            :workOrderNo="workOrderNo"
            :status="status"
            :choiceExcutor="choiceExcutor"
            :jumpType="jumpType"
            :instStatus="instStatus"
            :leaderId="leaderId"
          />
          <!-- <ProcessRecord :instId="procInstId"/> -->
        </div>
      </div>
      <!-- 发起沟通 -->
      <TaskToCommu ref="taskToCommu" :instId="procInstId" :defId="defId" />
      <!-- 跟踪设置 -->
      <TaskFollow ref="taskFollow" :instId="procInstId" :defId="defId" />
      <!-- 流程图 -->
      <TaskImage
        ref="taskImage"
        :bpmnInstId="bpmnInstId"
        :instId="procInstId"
      />
      <!-- 相关信息 -->
      <RelatedInformation ref="relatedInformation" :instId="procInstId" />
      <!-- 流程传阅-->
      <TaskToCopyTo
        ref="taskToCopyTo"
        :taskId="copyTaskId"
        :instId="procInstId"
      />
      <!-- 流程催办 -->
      <TaskUrgent
        ref="taskUrgent"
        :instId="procInstId"
        :defId="defId"
        :subject="subject"
      />
      <!-- 催办记录 -->
      <UrgentRecord
        ref="urgentRecord"
        :promoterId="promoterId"
        :instId="procInstId"
      />
      <!-- 修改记录 -->
      <ModifyRecord ref="modifyRecord" :instId="procInstId" />
      <FlowPrint
        ref="flowPrint"
        :formKey="formKey"
        :instId="procInstId"
        @printWordTemplate="printWordTemplate"
        @printHtml="printHtml"
      />
      <el-dialog
        title="审批历史"
        :close-on-click-modal="false"
        :visible.sync="infoDialogVisible"
        top="8vh"
        append-to-body
        width="90%"
        class="process_record"
        v-dialogDrag
      >
        <ProcessRecord
          :instId="procInstId"
          :taskId="taskId"
          :referOpinion="referOpinion"
          :nodeType="nodeType"
          :defId="defId"
          :nodeId="nodeId"
        />
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import FormContent from "@/components/flow/formContent.vue";
import RelatedInformation from "@/components/flow/relatedInformation.vue";
import FlowAction from "@/components/flow/flowAction.vue";
import DoneAction from "@/components/flow/doneAction.vue";
import ProcessRecord from "@/components/flow/processRecord.vue";
import TaskToCopyTo from "@/components/flow/task/taskToCopyTo.vue";
import TaskToCommu from "@/components/flow/task/taskToCommu.vue";
import TaskFollow from "@/components/flow/task/taskFollow.vue";
import TaskImage from "@/components/flow/task/taskImage.vue";
import UrgentRecord from "@/components/flow/urgentRecord.vue";
import ModifyRecord from "@/components/flow/modifyRecord.vue";
import TaskUrgent from "@/components/flow/task/taskUrgent.vue";
import FlowPrint from "@/components/flow/flowPrint.vue";
import req from "@/request.js";
import utils from "@/utils.js";
import directives from "@/directives.js";
import { Loading } from "element-ui";
import { mapState, mapActions } from "vuex";
import iframeSrcVue from "../common/iframeSrc.vue";

export default {
  name: "task",
  components: {
    FormContent,
    FlowAction,
    ProcessRecord,
    TaskToCommu,
    TaskFollow,
    TaskImage,
    RelatedInformation,
    TaskToCopyTo,
    UrgentRecord,
    ModifyRecord,
    TaskUrgent,
    DoneAction,
    FlowPrint,
  },
  props: [
    "task_state",
    "instId",
    "type",
    "taskId",
    "readId",
    "leaderId",
    "readDoneId",
    "myReadType",
  ],
  data() {
    return {
      isLook: false,
      isProcessRecord: false,
      infoDialogVisible: false,
      tasks: {}, //任务详情
      task_l: 12,
      task_r: 12,
      task_header_s: "width:100%;",
      procInstId: this.instId,
      copyTaskId: this.taskId,
      defId: "",
      bpmnInstId: "",
      subject: "",
      workOrderNo: "", //工单号
      status: "",
      instStatus: "",
      choiceExcutor: "",
      show: true,
      jumpType: "",
      promoterId: "",
      execId: "",
      selectNodeId: "",
      approvalArea: "", //审批区域显示的内容
      referOpinion: true, //允许参考意见 (选择否，则审批时不允许参考同环节其他会签人员的意见)
      nodeType: "", //当前任务类型
      nodeId: "", //当前任务节点
      isNodeIdOne: false, //是否是用户任务1节点（即发起人节点）
      showModifyRecord: false, //是否显示表单修改记录
      formKey: "",
      opinionField: "", //审批意见反填字段
      appendOpinion: "", //是否覆盖审批意见
      opinionFieldList: [], //所有任务节点的绑定的意见回填,
      showCopyBtn: false,
      showDelete: false
    };
  },
  watch: {
    defId: function(newVal, oldVal) {
      if (newVal) {
        const this_ = this;
        this_.opinionFieldList = [];
        this_.$store
          .dispatch("storeProcess/getNodeDefs", newVal)
          .then((rows) => {
            if (rows.length > 0) {
              for (let i = 0; i < rows.length; i++) {
                if (rows[i].localProperties.opinionField) {
                  this_.opinionFieldList.push(
                    "data." + rows[i].localProperties.opinionField
                  );
                }
              }
              this_.opinionFieldList = this_.opinionFieldList.unique();
            }
          });
      }
    },
    deep: true,
  },
  methods: {
    checkShowDelete(){
      if(this.type == 'request'){
        let {instStatus} = this;
        if(instStatus && (instStatus == 'backToStart' || instStatus == 'revokeToStart' )){
          this.showDelete = true;
        }
        if(instStatus == 'revoke' || instStatus == 'back'){
          this.$http.get(`${window.context.bpmRunTime}/runtime/instance/v1/isInstanceBackToStart?instId=${this.instId}&defId=${this.defId}&status=${instStatus}`).then(resp=>{
            if(resp.data && resp.data.value){
              this.showDelete = true;
            }
          })
        }
      }
    },
    //复制流程
    copeInst() {
      this.$confirm(
        "此操作将把当前实例数据复制到新流程待启动,是否继续?",
        "提示",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
            this.$store
          .dispatch("storeProcess/getMaindefId", this.defId).then((resp) => {//获取主版本
             //this.defId = resp.defId1;
             if(resp.defId1){
               this.$router.push("/agentStart/" + resp.defId1 + "/0/" + this.instId);
             }else{
                this.$message({
                  message: "出现异常！",
                  type: "warning",
                });
                return false;
             }
          })
        })
        .catch(() => {});
    },
    //流程催办
    taskUrgent() {
      this.$store.dispatch("storeProcess/isEnd", this.procInstId).then(() => {
        this.$refs.taskUrgent.handleClose(); //父组件调用子组件方法
      });
    },
    //催办记录
    urgentRecord() {
      this.$refs.urgentRecord.handleClose(); //父组件调用子组件方法
    },
    //表单修改记录
    openModifyRecord() {
      this.$refs.modifyRecord.handleClose(); //父组件调用子组件方法
    },
    //流程传阅
    taskToCopyTo() {
      if (this.type && this.type == "doneList") {
        this.selectNodeId = this.$refs.doneAction.getSelectNodeId();
      }
      this.$refs.taskToCopyTo.handleClose(this.selectNodeId, this.copyTaskId); //父组件调用子组件方法
    },
    //发起沟通
    taskToCommu() {
      this.$store.dispatch("storeProcess/isEnd", this.procInstId).then(() => {
        this.$refs.taskToCommu.handleClose(); //父组件调用子组件方法
      });
    },
    //跟踪设置
    taskFollow() {
      this.$store.dispatch("storeProcess/isEnd", this.procInstId).then(() => {
        this.$refs.taskFollow.handleOpen(); //父组件调用子组件方法
      });
    },
    //流程图
    taskImage() {
      this.$refs.taskImage.handleOpen(); //父组件调用子组件方法
    },
    //相关信息
    relatedInformation() {
      this.$refs.relatedInformation.handleClose(); //父组件调用子组件方法
    },
    //打印
    showPrint() {
      let this_ = this;
      this_.savePrintCount();
      if (!this.formKey || this.formKey == "") {
        if (!this.nodeId) {
          this.nodeId = "";
        }
        var url =
          "${bpmRunTime}/runtime/instance/v1/printBoAndFormKey?defId=" +
          this.defId +
          "&nodeId=" +
          this.nodeId +
          "&procInstId=" +
          this.procInstId;
        req.get(url).then((res) => {
          if (res.data) {
            this.formKey = res.data.formKey;
            let param = {
              pageBean: { page: 1, pageSize: 20, total: 0 },
              querys: [
                {
                  group: "defaultQueryGroup",
                  operation: "EQUAL",
                  relation: "AND",
                  property: "formKey",
                  value: this.formKey,
                },
              ],
            };
            req
              .post(
                req.getContext().form + "/form/printTemplate/v1/getPrintList",
                param
              )
              .then((response) => {
                if (response.data.rows && response.data.rows.length > 0) {
                  this.$refs.flowPrint.handleClose(this.workOrderNo); //父组件调用子组件方法
                } else {
                  this_.printHtml();
                }
              });
          }
        });
      } else {
        let param = {
          pageBean: { page: 1, pageSize: 20, total: 0 },
          querys: [
            {
              group: "defaultQueryGroup",
              operation: "EQUAL",
              relation: "AND",
              property: "formKey",
              value: this.formKey,
            },
          ],
        };
        req
          .post(
            req.getContext().form + "/form/printTemplate/v1/getPrintList",
            param
          )
          .then((response) => {
            if (response.data.rows && response.data.rows.length > 0) {
              this.$refs.flowPrint.handleClose(this.workOrderNo); //父组件调用子组件方法
            } else {
              this_.printHtml();
            }
          });
      }
    },
    //未设置word套打模板，直接调用打印
    printHtml(data) {
      this.$root.$emit("printForm", false);
      if (this.type != "doneList") {
        this.$refs.flowAction.hiddenOpertion();
      } else {
        this.$refs.doneAction.hiddenOpertion();
      }
      document.getElementsByName("task_vue")[0].style.width = "270mm";
      $(".form-table").find("th").css({"min-width":"100%"});//20220919 曾琦 自适应谷歌打印模板 
      
      // if(document.getElementsByClassName("main-title") && document.getElementsByClassName("main-title").length>0){
      //   for(let i =0;i<document.getElementsByClassName("main-title").length;i++){
      //       document.getElementsByClassName("main-title")[i].style.minWidth="110px";
      //   }
      // }
      // let height_e = document.getElementsByClassName(
      //   "edui-editor-iframeholder"
      // )[0].style.height;
    //  document.getElementsByTagName('body')[0].style.zoom=0.7;
      setTimeout(() => {
        this.$root.$emit("printForm", true);
        setTimeout(() => {
          window.print();
          utils.reload();
        }, 1000);
      }, 1000);
    },
    printWordTemplate(data) {
      if (!data) {
        this.$message({
          message: "请选择打印模板",
          type: "warning",
        });
        return false;
      }
      if (data && data.printType == "form") {
        this.$message({
          message: "请选择word套打模板",
          type: "warning",
        });
        return false;
      }
      Loading.service("表单打印中");
      var url =
        "${form}/form/printTemplate/v1/wordPrint?id=" +
        data.id +
        "&defId=" +
        this.defId +
        "&nodeId=" +
        this.nodeId +
        "&procInstId=" +
        this.procInstId;
      req.get(url).then((res) => {
        let loadingInstance = Loading.service("表单打印中");
        if (!res.data.state) {
          this.$message({
            message: res.data.message,
            type: "warning",
          });
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        } else {
          req
            .download(
              "${portal}/system/file/v1/downloadFile?fileId=" + res.data.value
            )
            .then((r) => {
              this.$nextTick(() => {
                // 以服务的方式调用的 Loading 需要异步关闭
                loadingInstance.close();
              });
            });
        }
      });
    },
    savePrintCount() {
      // 添加打印次数
      let instId = "";
      if (this.type != "doneList") {
        this.$refs.flowAction.$refs.formContent.isPrint = true;
        instId = this.$refs.flowAction.$refs.formContent.instId;
      } else {
        this.$refs.doneAction.$refs.doneFormContent.isPrint = true;
        instId = this.$refs.doneAction.$refs.doneFormContent.instId;
      }

      req
        .post("${bpmRunTime}/runtime/bpmPrintRecord/v1/savePrint/" + instId)
        .then(() => {
          if (this.type != "doneList") {
            this.$refs.flowAction.$refs.formContent.printCount =
              parseInt(this.$refs.flowAction.$refs.formContent.printCount) + 1;
          } else {
            this.$refs.doneAction.$refs.doneFormContent.printCount =
              parseInt(this.$refs.doneAction.$refs.doneAction.printCount) + 1;
          }
        });
    },
    deleteBpm(){
      this.$confirm("删除后，单据无法恢复，请确认是否继续删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "继续删除",
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.$store.dispatch("storeProcess/restore", this.instId).then(()=>{
          setTimeout(()=>{
            window.close();
          },2000)
        })
      });
    }
  },
  created() {
    //不是待办进来
    if (!this.taskId && this.type != "read" && !this.myReadType) {
      //是否是查看实例页面
      // this.isLook=true;
      this.task_l = 11;
      this.task_r = 13;
    }
    // 我的请求进来的都显示复制按钮
    if (this.myReadType == "myRequest") {
      this.isLook = true;
    }
    if(this.isLook || this.type == "request"){
      this.showCopyBtn = true;
    }
    //兼容模块开发功能查看审批页面
    let global_width = $(window).width();
    if (global_width < 1600) {
      this.task_header_s = "width:100%;margin-top:0px !important;";
    }
    //兼容只显示审批页面时
    if (this.$route.meta.single) {
      this.task_header_s = "width:100%;margin-top:0px;";
    }
    window.agentLeaderId = this.leaderId;
    let this_ = this;
    if (this.instId == undefined) {
      this.$store
        .dispatch("storeProcess/getNotice", this.taskId)
        .then((tasks) => {
          this_.tasks = tasks;
          this_.procInstId = tasks.bpmTask.procInstId;
          this_.defId = tasks.bpmTask.procDefId;
          this_.bpmnInstId = tasks.bpmTask.bpmnInstId;
          this_.subject = tasks.bpmTask.subject;
          this_.workOrderNo = tasks.bpmTask.workOrderNo;
          this_.status = tasks.bpmTask.status;
          this_.execId = tasks.bpmTask.execId;
          this_.instStatus = tasks.bpmTask.instStatus;
          //判断是否有审批流程轨迹
          if (tasks.bpmDefLayout.listLayout.length) {
            //判断审批轨迹第一个节点是否是开始节点
            if (tasks.bpmDefLayout.listLayout[0].nodeType == "START") {
              //判断当前任务节点是否是用户任务1节点（即发起人节点）
              if (
                tasks.curNodeDef &&
                tasks.bpmDefLayout.listLayout[1].nodeId ==
                  tasks.curNodeDef.nodeId &&
                tasks.curNodeDef.type == "USERTASK"
              ) {
                this_.isNodeIdOne = true;
              }
            }
          }
          if (tasks.curNodeDef && tasks.curNodeDef.nodeProperties) {
            this.nodeType = tasks.curNodeDef.type;
            this.nodeId = tasks.curNodeDef.nodeId;
            let nodeProperties =
              tasks.curNodeDef.nodeProperties[0] ||
              tasks.curNodeDef.localProperties;
            this.choiceExcutor = nodeProperties.choiceExcutor;
            this.jumpType = nodeProperties.jumpType;
            this.approvalArea = nodeProperties.approvalArea;
            this.opinionField = nodeProperties.opinionField;
            this.appendOpinion = nodeProperties.appendOpinion;
            if (this.approvalArea.indexOf("processRecord") == -1) {
              this.isProcessRecord = true;
            }
            this.referOpinion = nodeProperties.referOpinion;
          }
          //是否显示表单修改记录
          if (tasks.showModifyRecord) {
            this_.showModifyRecord = true;
          }
          //表单formKey
          this_.formKey = tasks.formKey;
          if (!this.bpmnInstId && this.status != "COMMU") {
            this.$store.dispatch("storeProcess/noticeTurnDode", this.taskId); //知会任务待办转已办
          }
        });
      this.$store.dispatch("storeProcess/addReadRecord", this.taskId); //添加阅读记录
    } else {
      this.$store
        .dispatch("storeProcess/getInstanceByInstId", this.instId)
        .then((insts) => {
          this.approvalArea = "processRecord";
          this.defId = insts.procDefId;
          this.bpmnInstId = insts.bpmnInstId;
          this.subject = insts.subject;
          this.workOrderNo = insts.workOrderNo;
          this.instStatus = insts.status;
          //是否显示表单修改记录
          if (insts.showModifyRecord) {
            this.showModifyRecord = true;
          }
          //表单formKey
          this.formKey = insts.bpmFormKey;
        });
      //知会任务待办转已办(待阅列表进来的)
      if (this.readId && !this.myReadType) {
        this.$store.dispatch("storeProcess/noticeTurnDode", this.readId);
      }
      //获取知会任务待办详情
      if (this.readId) {
        this.$store
          .dispatch("storeProcess/getBpmTaskNoticeById", this.readId)
          .then((row) => {
            if (row.taskId) {
              this.copyTaskId = row.taskId;
            } else if (row.nodeId) {
              this.selectNodeId = row.nodeId;
            }
          });
      }
      //获取知会任务已办详情
      if (this.readDoneId) {
        this.$store
          .dispatch("storeProcess/getBpmTaskNoticeDoneById", this.readDoneId)
          .then((row) => {
            if (row.taskId) {
              this.copyTaskId = row.taskId;
            } else if (row.nodeId) {
              this.selectNodeId = row.taskKey;
            }
          });
      }
    }
    //获取当前用户ID
    this.promoterId = JSON.parse(sessionStorage.getItem("currentUser")).userId;
    this.checkShowDelete();
  },
  mounted() {
    window.jQuery("#app").find(".el-header").first().hide();
    $("#app").find(".btn_region").first().css("top", "48px");
    window.jQuery("#app").find("#hymenu").css("width","0px;");
    window.jQuery("#app").find("#hycontent").css("width","100%;");
      document.getElementsByTagName('body')[0].style.zoom=1;
  },
  computed: {
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
#printTest1 {
  width: 100%;
  height: auto;
}

.el-header {
  padding: 0;
}

.top-subject-col {
  // text-align: right;
  color: #666;
  font-weight: normal;
  margin: 4px 0;
}
.flow-subject {
  text-align: right;
  color: #666;
  margin-top: 18px;
}

.top-btns-col {
  height: 32px;
  line-height: 32px;
  text-align: right;
}

.top-btns-col > button {
  color: #666;
}

.top-btns-col > button /deep/ span {
  margin-left: 3px;
}

.top-btns-col > button:hover {
  color: $--theme-color;
}

.text {
  font-size: 14px;
}


.task-card {
  width: 1360px;
  background: #fff;
  padding-top: 140px;
}
.task-card_not {
  width: 1360px;
  background: #fff;
  padding-top: 20px;
}
.task_header {
  position: fixed;
  z-index: 100;
  padding: 0px !important;
}
.btn_region_in {
  background-color: #e9eef3;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  padding-left: 16px;
}
.process_record {
  /deep/.el-dialog__body {
    padding: 0 20px;
  }
}
/deep/.el-form-item__error {
  display: none;
}
.header-wrap{
  // overflow: auto;
  height: 30px;
}
@page {
  size: auto;
  margin-top: 1.2cm; /* 国家标准公文页边距 GB/T 9704-2012 */
  margin-bottom: 1.2cm; /* 国家标准公文页边距 GB/T 9704-2012 */
  margin-left: 1cm; /* 国家标准公文页边距 GB/T 9704-2012 */
  margin-right: 1cm; /* 国家标准公文页边距 GB/T 9704-2012 */
  @bottom-left{/* 页面内容区域底部添加一条 1px 的灰线 */
    border-top: 1px solid gray;
  }
  @bottom-center{
    border-top: 1px solid gray;
  }
  @bottom-right {
    border-top: 1px solid gray;
  }
  @bottom-center {/* 页脚中间显示格式如 "第 3 页" 的页码 */
    content: "第" counter(page) "页";
  }
}
@media print {

  .notprint {
    display: none;
  }
  /deep/ .el-main {
    // 隐藏滚动条
    &::-webkit-scrollbar {
      width: 0;
      background-color: transparent;
    }
    /*火狐下隐藏滚动条*/
    scrollbar-width: none;
  }
}
@media (max-width: 1024px) {
  .task_header{
    width: 95% !important;
  }
}


</style>
